export default __webpack_public_path__ + "static/media/keep-cup-logo.svg";